"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const ConnectorWallPlug = (props) => {
    const { width, height, color } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 24 24", testID: "connectorIcon-WallPlug" },
        react_1.default.createElement(react_native_svg_1.G, { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement(react_native_svg_1.Path, { d: "M0 0h24v24H0z" }),
            react_1.default.createElement(react_native_svg_1.Path, { d: "M14.51 2a5.275 5.275 0 0 1 5.113 3.973c1.186 4.652 1.935 7.785 2.247 9.4l.03.156A5.466 5.466 0 0 1 16.527 22H7.47a5.466 5.466 0 0 1-5.424-6.138l.051-.333c.293-1.564 1.052-4.75 2.278-9.556A5.275 5.275 0 0 1 9.488 2h5.021zM9.826 14.956H5.37v2.323h4.458v-2.323zm8.801 0H14.17v2.323h4.458v-2.323zm-5.53-10.603h-2.2v4.706h2.2V4.353z", fill: color }))));
};
ConnectorWallPlug.defaultProps = {
    color: 'currentColor',
    width: 20,
    height: 24,
};
exports.default = react_1.default.memo(ConnectorWallPlug);
